export const CREATE_JOB_LISTING = gql`
  mutation createJobListing($input: CreateJobListingInput!) {
    createJobListing(input: $input) {
      jobPostingDate
      status
      title
      type
      subtitle
      description
      benefits
      payMin
      payMax
      payUnit
      payCurrency
      employmentType
      licenseClass
      endorsements
      minMonthsExperience
      numberOfHires
      hiringTimeline
      minEmploymentHistoryYears
      address {
        street
        city
        state
        country
        zipCode
      }
    }
  }
`

export const UPDATE_JOB_LISTING = gql`
  mutation updateJobListing($id: String!, $input: UpdateJobListingInput!) {
    updateJobListing(id: $id, input: $input) {
      jobPostingDate
      status
      title
      type
      subtitle
      description
      benefits
      payMin
      payMax
      payUnit
      payCurrency
      employmentType
      licenseClass
      endorsements
      minMonthsExperience
      numberOfHires
      hiringTimeline
      minEmploymentHistoryYears
      address {
        street
        city
        state
        country
        zipCode
      }
      employees {
        employeeId
        firstName
        lastName
      }
      memberEmployees {
        employeeId
        firstName
        lastName
        status
      }
      jobListingTemplate {
        jobListingTemplateId
        name
      }
    }
  }
`

export const DELETE_JOB_LISTING = gql`
  mutation deleteJobListing($id: String!) {
    deleteJobListing(id: $id) {
      title
    }
  }
`

export const GET_JOB_LISTINGS = gql`
  query getJobListings(
    $filters: JobListingFiltersInput
    $pageInfo: PageInfoInput
  ) {
    jobListings(filters: $filters, pageInfo: $pageInfo) {
      items {
        jobListingId
        createdAt
        updatedAt
        jobPostingDate
        status
        title
        type
        employees(statuses: [ACTIVE, ARCHIVED]) {
          employeeId
          firstName
          lastName
          roleType
          coverImage
          status
        }
        memberEmployees(statuses: [ACTIVE, ARCHIVED]) {
          employeeId
          firstName
          lastName
          status
        }
        address {
          street
          city
          state
          country
          zipCode
        }
        trackingLinks {
          trackingLinkId
          linkType
          linkName
        }
      }
      pageInfo {
        offset
        limit
      }
      totalCount
    }
  }
`

export const GET_JOB_LISTING = gql`
  query getJobListing($id: String!) {
    jobListing(id: $id) {
      jobListingId
      jobPostingDate
      status
      title
      type
      subtitle
      description
      benefits
      payMin
      payMax
      payUnit
      payCurrency
      employmentType
      licenseClass
      endorsements
      minMonthsExperience
      numberOfHires
      hiringTimeline
      minEmploymentHistoryYears
      address {
        street
        city
        state
        country
        zipCode
      }
      employees(statuses: [ACTIVE, ARCHIVED]) {
        employeeId
        firstName
        lastName
        status
      }
      memberEmployees(statuses: [ACTIVE, ARCHIVED]) {
        employeeId
        firstName
        lastName
        status
      }
      jobListingTemplate {
        jobListingTemplateId
        name
        status
      }
    }
  }
`

export const GET_JOB_LISTINGS_ONLY = gql`
  query getJobListingsOnly(
    $filters: JobListingFiltersInput
    $pageInfo: PageInfoInput
  ) {
    jobListings(filters: $filters, pageInfo: $pageInfo) {
      items {
        jobListingId
        createdAt
        updatedAt
        jobPostingDate
        status
        title
      }
      pageInfo {
        offset
        limit
      }
      totalCount
    }
  }
`

export const GET_JOB_LISTING_TEMPLATE_QUESTIONS = gql`
  query getJobListingTemplateQuestions($id: String!) {
    jobListing(id: $id) {
      jobListingId
      jobListingTemplate {
        jobListingTemplateId
        questions {
          jobListingTemplateQuestionId
          isRequired
          visibility
          order
          question {
            customQuestionId
            label
            placeholder
            helpText
            fieldType
            options {
              customQuestionOptionId
              label
              order
            }
          }
        }
      }
    }
  }
`

export const BULK_UPDATE_JOB_LISTING_EMPLOYEES = gql`
  mutation bulkUpdateJobListingEmployees(
    $input: BulkUpdateJobListingEmployeesInput!
  ) {
    bulkUpdateJobListingEmployees(input: $input) {
      results {
        jobListingId
        success
        errorMsg
      }
    }
  }
`
